import { BusinessObjectBase, ModelBase, QueryBus } from '@skylab-shared/core';
import { ExchangeRateModel } from '@skylab-shared/dataModel';
import { CompanyParametersQuery } from '../../company/queries/company-parameters.query-base';
import { CurrencyExchangeRate, CurrencyExchangeRateQuery } from '../../currency/queries/currency-exchange-rate.query-base';
import { CurrencyCollectionQuery } from '../../currency/queries/currency.query-base';
import { rewriteExchangeRateItemToDocumentExchangeRateModel } from '../../documents/utils/document-exchange-rate-utils';

interface ModelPart extends ModelBase {
    currencyId: number;
    exchangeRate: ExchangeRateModel | null;
}

export abstract class ExchangeRateMixin<TModel extends ModelPart> extends BusinessObjectBase<TModel>  {
    protected abstract calculateDateForCurrencyExchangeRate: () => Date;
    protected queryBus: QueryBus;

    public async refreshExchangeRateAsync(date = this.calculateDateForCurrencyExchangeRate()): Promise<void> {
        if (this.inForeignCurrency()) {
            if (!this.model.exchangeRate) {
                const exchangeRateModel = new ExchangeRateModel();
                this.model.exchangeRate = exchangeRateModel;
                rewriteExchangeRateItemToDocumentExchangeRateModel(this.model.exchangeRate, this.getDefaultRate(date));
            }

            const rate = await this.getExchangeRateAsync(date) || this.getDefaultRate(date);
            rewriteExchangeRateItemToDocumentExchangeRateModel(this.model.exchangeRate, rate);
        } else {
            this.model.exchangeRate = null;
        }
    }

    public inForeignCurrency(): boolean {
        const { systemCurrency } = this.localContext.getPreloaded(CompanyParametersQuery);
        const pln = this.localContext.firstPreloaded(CurrencyCollectionQuery, { symbol: systemCurrency });
        return this.model.currencyId !== pln.id;
    }

    private getExchangeRateAsync(date: Date): Promise<CurrencyExchangeRate | null> {
        const { symbol } = this.localContext.firstPreloaded(CurrencyCollectionQuery, { id: this.model.currencyId });
        return this.queryBus.queryAsync(new CurrencyExchangeRateQuery({currency: symbol, date: date}));
    }

    private getDefaultRate(date: Date): CurrencyExchangeRate {
        return { date: date, units: 1, rate: 1, tableNo: null, manual: false };
    }
}
